<div ngbDropdown placement="bootom-end" #dropdown="ngbDropdown" autoClose="outside" class="notification-bell">
  <span *ngIf="notificationsNumber" class="notification-counter">{{ notificationsNumber }}</span>
  <span
    ngbDropdownToggle
    class="d-inline-block"
    id="notification-dropdown-toggle"
    [ngStyle]="{
      'pointer-events': notificationEngineConnected ? 'auto' : 'none'
    }"
  >
    <svg-icon src="assets/icons/icon-bell.svg" class="icon-bell"> </svg-icon>
  </span>
  <div ngbDropdownMenu aria-labelledby="notification-dropdown-toggle" class="notification-dropdown">
    <app-notifications-counter
      [notificationNumber]="notificationsNumber"
      [informationalNotificationsNumber]="informationalNotificationsNumber"
      (onDismissAllEmitter)="onDismissAll()"
    >
    </app-notifications-counter>

    <ng-template #viewContainer> </ng-template>
  </div>
</div>
